import React from "react";
import DefaultLayout from "./layouts/default";
import BannerLayout from "./layouts/banner";
import MinimalisticLayout from "./layouts/minimalistic";
import FeatureLayout from "./layouts/feature";
import ClassicLayout from "./layouts/classic";

const CardsCarousel = ({ data }) => {
	switch (data.layout) {
		case "default":
			return <DefaultLayout data={data} />;
		case "bannerMode":
			return <BannerLayout data={data} />;
		case "minimalistic":
			return <MinimalisticLayout data={data} />;
		case "feature":
			return <FeatureLayout data={data} />;
		case "classic":
			return <ClassicLayout data={data} />;

		default:
			return null;
	}
};

export default CardsCarousel;